<div class="relative min-h-screen flex flex-col lg:grid lg:grid-cols-2 overflow-hidden">
  <!-- Bottom-left pattern + gradient overlay -->
  <img
    src="/pattern.svg"
    alt=""
    class="absolute -bottom-8 -left-22 pointer-events-none select-none w-85 h-46 opacity-80"
  />
  <div
    class="absolute -bottom-8 -left-22 pointer-events-none w-85 h-46"
    style="
      background:
        linear-gradient(to bottom, #1e293b 0%, transparent 20%),
        linear-gradient(to left, #1e293b 0%, transparent 20%);
    "
  ></div>

  <!-- Left: Logo -->
  <div class="flex items-center justify-center pt-10 pb-4 lg:py-0">
    <div class="flex items-center gap-5">
      <img src="/icons/logo.svg" alt="JCCA" class="h-7 lg:h-9" />
    </div>
  </div>

  <!-- Right: Card + footer -->
  <div
    class="flex flex-col flex-1 items-center justify-center gap-5 px-6 sm:px-12 lg:px-16 pb-16 lg:pb-0"
  >
    <!-- White card -->
    <div
      class="flex flex-col items-center justify-center bg-white rounded-3xl p-8 sm:p-12 w-full max-w-md lg:max-w-96 lg:h-92"
    >
      <h1 class="text-lg font-semibold text-navy-600 text-center mb-3">
        Welcome to JCCA Incidents &amp; Investigations Portal
      </h1>
      <p class="text-xs text-slate-500 text-center leading-relaxed mb-10">
        Use your JCCA credentials to manage incidents and investigations. Please sign in with your
        organizational account.
      </p>

      @if (error()) {
        <div
          class="mb-6 rounded-xl px-4 py-3 flex items-start gap-3 bg-red-50 border border-red-200 w-full"
        >
          <svg
            class="shrink-0 mt-0.5"
            width="16"
            height="16"
            fill="none"
            stroke="#ef4444"
            stroke-width="2"
            viewBox="0 0 24 24"
          >
            <circle cx="12" cy="12" r="10" />
            <line x1="12" y1="8" x2="12" y2="12" />
            <line x1="12" y1="16" x2="12.01" y2="16" />
          </svg>
          <p class="text-sm text-red-600">{{ error() }}</p>
        </div>
      }

      <button
        (click)="login()"
        [disabled]="loading()"
        class="w-full flex items-center justify-center gap-3 rounded-lg border border-surface-300 bg-surface-100 py-3.5 px-6 text-xs font-medium text-slate-600 hover:bg-gray-50 transition-colors cursor-pointer disabled:opacity-60 disabled:cursor-not-allowed"
      >
        @if (loading()) {
          <svg class="animate-spin" width="18" height="18" fill="none" viewBox="0 0 24 24">
            <circle cx="12" cy="12" r="10" stroke="rgba(0,0,0,0.15)" stroke-width="3" />
            <path
              d="M12 2a10 10 0 0 1 10 10"
              stroke="#374151"
              stroke-width="3"
              stroke-linecap="round"
            />
          </svg>
          Connecting...
        } @else {
          <svg width="20" height="20" viewBox="0 0 21 21" xmlns="http://www.w3.org/2000/svg">
            <rect x="1" y="1" width="9" height="9" fill="#f25022" />
            <rect x="11" y="1" width="9" height="9" fill="#7fba00" />
            <rect x="1" y="11" width="9" height="9" fill="#00a4ef" />
            <rect x="11" y="11" width="9" height="9" fill="#ffb900" />
          </svg>
          Sign in with Microsoft
        }
      </button>
    </div>

    <p class="text-xs text-white">
      Problems to log in?
      <a
        href="mailto:support@jcca.org"
        class="text-slate-500 underline underline-offset-2 hover:text-white/80 transition-colors"
      >
        Contact support now
      </a>
    </p>

    <div class="flex gap-6 text-xs text-white/25">
      <a href="#" class="hover:text-white/50 transition-colors">Terms of Service</a>
      <a href="#" class="hover:text-white/50 transition-colors">Privacy Policy</a>
    </div>
  </div>
</div>
